import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  backToAccountSelection: {
    defaultMessage: 'Try again',
    id: 'AccountSelectionPage.backToAccountSelection',
  },
  successText: {
    defaultMessage: 'Your payment is on the way.',
    id: 'AccountSelectionPage.paymentSuccessfullySent',
  },
  duplicatePayment: {
    defaultMessage: 'Payment already registered',
    id: 'TransferErrors.duplicatePayment',
  },
  failedTextSourceAccount: {
    defaultMessage: "This payment couldn't be completed. Please go back and try again.",
    id: 'TransferErrors.failedTextSourceAccount',
  },
  insufficientFunds: {
    defaultMessage: 'Not enough funds on the selected account.',
    id: 'AccountSelectionPage.insufficientFunds',
  },
});
